import axios from "axios";

const apiUrl = process.env.REACT_APP_ART_THERAPY_API;
const fetchArtTherapyData = async () => {
  try {
    const response = await axios.get(`${apiUrl}/registrations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching art therapy data:", error);
    throw error;
  }
};

const postArtTherapyData = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/register`, data);
    return response.data;
  } catch (error) {
    console.error("Error posting art therapy data:", error);
    throw error;
  }
};

const updateArtTherapyData = async (id, data) => {
  try {
    const response = await axios.put(`${apiUrl}/payment/${id}`, data,{
        headers: {
          "Content-Type": "application/json",
  }});
    return response.data;
  } catch (error) {
    console.error("Error updating art therapy data:", error);
    throw error;
  }
};

export { fetchArtTherapyData, postArtTherapyData, updateArtTherapyData };
